/**
 * Admin Email Whitelist
 *
 * This file contains the list of authorized admin emails that have access
 * to the admin dashboard and its features.
 */

const ADMIN_EMAILS = [
  'l.veldman@indus-bulklogistics.com',
  'a.visscher@indus-bulklogistics.com',
  'j.vansantbrink@indus-bulklogistics.com',
  'r.denhertog@indus-bulklogistics.com'
];

/**
 * Check if an email is in the admin whitelist
 * @param {string} email - The email address to check
 * @returns {boolean} - True if the email is an admin, false otherwise
 */
export const isAdminEmail = (email) => {
  if (!email) return false;

  // Normalize email to lowercase for case-insensitive comparison
  const normalizedEmail = email.toLowerCase().trim();

  return ADMIN_EMAILS.some(
    adminEmail => adminEmail.toLowerCase() === normalizedEmail
  );
};

/**
 * Get the list of admin emails (for reference)
 * @returns {string[]} - Array of admin email addresses
 */
export const getAdminEmails = () => [...ADMIN_EMAILS];
